import { Button } from "@/components";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetDescription,
} from "@/components/ui/sheet";
import ChannelForm from "./ChannelForm";
import { MdOutlineBlock } from "react-icons/md";
import { IoIosAddCircle } from "react-icons/io";
import { useState } from "react";

const AvailableChannel = ({ channelTypes, onIntegrate, AlertDialog }) => {
  // Show all channel types, including out of service ones
  const availableChannelTypes = Object.values(channelTypes);

  if (availableChannelTypes.length === 0) return null;

  return (
    <div className="flex flex-col gap-4 mt-5">
      <h2 className="md:text-headline3 text-headline4 font-nunito text-secondary-90 font-semibold">
        Available Channels
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 w-full">
        {availableChannelTypes.map((channel) => {
          const [open, setOpen] = useState(false);
          return (
          <div
            key={channel.id}
            className="flex flex-col gap-6 bg-background_2 rounded-xl drop-shadow-sm p-6 items-center"
          >
            {channel.icon ? (
              <div className="flex-1 flex items-center justify-center">
                <img src={channel.icon} alt={channel.name.toLowerCase()} />
              </div>
            ) : (
              <div className="flex-1 flex items-center justify-center">
                <h2 className="md:text-headline2 text-headline4 text-secondary/95 font-bold font-nunito">
                  {channel.name}
                </h2>
              </div>
            )}

            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <Button
                  variant="default"
                  size="sm"
                  disabled={!channel.isServiceable}
                  className={
                    !channel.isServiceable
                      ? "!bg-rose-100 text-rose-800/80 hover:bg-gray-300 cursor-not-allowed border border-rose-200/80"
                      : ""
                  }
                  icon={!channel.isServiceable ? MdOutlineBlock : IoIosAddCircle}
                  iconClassName="!opacity-95"
                >
                  {channel.isServiceable ? "Integrate" : "Out of Service"}
                </Button>
              </SheetTrigger>
              {channel.isServiceable && (
                <SheetContent>
                  <SheetHeader>
                    <SheetTitle>Connect {channel.name}</SheetTitle>
                    <SheetDescription>
                    </SheetDescription>
                  </SheetHeader>
                  <ChannelForm
                    channelId={channel.id}
                    formFields={channel.formFields}
                    onConnect={onIntegrate}
                    AlertDialog={AlertDialog}
                    setOpen={setOpen}
                    />
                </SheetContent>
              )}
            </Sheet>
          </div>
        );
      })}
      </div>
    </div>
  );
};

export default AvailableChannel;
